<template>
  <div class="style-gallery">
    <div class="fullwidth small-bottom-padding">
      <div class="flex-start">
        <div class="sg-top" v-if="!$store.getters.isNonUkPt">
          <h1>{{ gallery.name }}</h1>
          <h2>{{ subhead }}</h2>
          <div class="sg-space"></div>
        </div>
        <h1 v-if="$store.getters.isNonUkPt">{{ $nippets.gallery.heading }}</h1>
        <search-widget right />
      </div>
      
      <div class="selector-panel">
        <style-selector :selectedId="gallery.gallery_id" :placeholder="$nippets.gallery.chooseStyle" />
      </div>
      <div class="button-panel">
        <small-button large :sel="mode === 'random'" v-on:click="changeMode('random')">{{ $nippets.allArtists.random }}</small-button>
        <small-button large :sel="mode === 'az'" v-on:click="changeMode('az')">{{ $nippets.allArtists.az }}</small-button>
        <location-selector v-model="location" v-on:input="changeRegion" />
      </div>
    </div>
    <transition name="fade">
      <div class="fullwidth no-top-padding" v-show="loaded">
        <style-grid :galleryData="galleryData" :gallery="gallery" :specialists="showSpecialists" />
        <div class="a-right">
          <top-button />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LocationSelector from '@/components/widgets/LocationSelector.vue'
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import StyleSelector from '@/components/widgets/StyleSelector.vue'
import StyleGrid from '@/components/panels/StyleGridV2.vue'
import TopButton from '@/components/buttons/TopButton.vue'
import MetatagPage from '@/mixins/MetatagPage.js'

const SHOW_STYLE_SPECIALISTS = false

export default {
  mixins: [MetatagPage],
  components: {
    LocationSelector,
    SearchWidget,
    StyleSelector,
    StyleGrid,
    TopButton
  },
  props: {
    url: String
  },
  data: function () {
    return {
      gallery: { gallery_id: '0'},
      galleryData: [],
      mode: 'random',
      location: 'ZZ',
      loaded: false,
      subhead: '',
      lhead: '',
      showSpecialists: SHOW_STYLE_SPECIALISTS
    }
  },
  created: function () {
    this.mode = this.$store.state.azSortMode
    this.location = this.$store.state.azLocation
    this.loadData()
  },
  methods: {
    
    loadData: async function () {
      this.loaded = false
      let t = new Date().getTime()
      console.log('fetching all data')
      
      this.gallery = await this.$store.dispatch('fetchGallery', '/styles/' + this.url)
      
      let lh = this.gallery.name.toLowerCase()
      this.lhead = `Choose from the widest and most diverse choice of ${lh} illustrators in the world`

      let gd = await this.$store.dispatch('fetchGalleryData', this.gallery.gallery_id)
      await this.$store.dispatch('fetchArtists')
      let t1 = new Date().getTime()
      let ms = t1 - t;
      console.log('done, took', ms)
      let artists = this.$store.getters.nonExcludedArtists.filter(el => el.artist_id)
      let lang = this.$store.state.lang.toLowerCase()
      if(this.location !== 'ZZ'){
        artists = artists.filter(el => el.region === this.location)
      }
      else {
        artists = artists.filter(el => { return (el.region !== 'DE' || el.show_on_all) })
        artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
      }
      gd = gd.filter(el => artists.find(al => al.artist_id === el.artist_id))
      this.sortArtists(gd)
      this.galleryData = gd
      let imurl = this.$k.getImageCrop500(gd[0].images[0].url)
      this.$k.setTwitterImage(imurl)
      this.loaded = true
      if(this.subhead === ''){
        this.subhead = this.lhead
      }
    },
    changeMode: function (modename) {
      this.mode = modename
      // TODO change order images load
      this.$store.commit('setAzSortMode', this.mode)
      this.loadData()
    },
    changeRegion: function (code) {
      this.location = code
      this.$store.commit('setAzLocation', this.location)
      this.loadData()
    },
    sortArtists: function (res) {
      if(this.mode === 'random'){
        res.sort((el, el1) => { 
          if(SHOW_STYLE_SPECIALISTS){
            if(el.specialist < el1.specialist) return 1
            if(el.specialist > el1.specialist) return -1
          }
          
          return (el.rnd - el1.rnd) 
        })
      }
      else if(this.mode === 'az') {
        res.sort((el, el1) => { 
          if(SHOW_STYLE_SPECIALISTS){
            if(el.specialist < el1.specialist) return 1
            if(el.specialist > el1.specialist) return -1
          }
          return el.name.localeCompare(el1.name) 
        })
      }
    },
    onLoadedMetatags(metatag) {
      if(metatag.subhead){
        this.subhead = metatag.subhead
      }
      else {
        if(this.lhead){
          this.subhead = this.lhead
        }
      }
    }
  },
  watch: {
    url: function () {
      this.subhead = ''
      this.loadMetatags()
      this.loadData()
      
    }
  }
}
</script>

<style>

  .sg-top{
    display:flex;
    align-items:flex-start;
    margin-bottom: 30px;
  }

  .style-gallery h1{
    width:50%;
  }

  .sg-top h1{
    margin:0 20px 0 0;
    width:440px;
  }

  .sg-top h2{
    width: 40%;
    margin:0 20px 0 0;
    color:#71716f;
    font-size:21px;
  }

  .sg-space{
    width:10%;
  }

  .style-selector{
    margin-right:10px;
  }

  

  @media screen and (max-width:1024px)
  {
    .sg-top{
      display:block;
    }

    .sg-top h2{
      width:auto;
      font-size:18px;
    }

    .sg-space{
      display:none;
    }
  }

  @media screen and (max-width:640px)
  {
    .style-gallery h1{
      width:100%;
      font-size:28px;
      line-height:32px;
    }

    .style-gallery .search-holder{
      display:none;
    }

    .sg-top h2{
      font-size:16px;
    }
  }
</style>
